import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { AdPreviewPaginationService } from './ad-preview-pagination.service';
import { CreativeUnitWithCustomizationsDto } from '../../../../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit.dto';

@Injectable()
export class adBuilderPagination implements MatPaginatorIntl {
	changes = new Subject<void>();

	itemsPerPageLabel = $localize`:Paginator label@@paginatorItemsPerPageLabel:Items per page:`;

	firstPageLabel = $localize`:Paginator label@@paginatorFirstPageLabel:First page`;
	lastPageLabel = $localize`:Paginator label@@paginatorLastPageLabel:Last page`;
	nextPageLabel = $localize`:Paginator label@@paginatorNextPageLabel:Next page`;
	previousPageLabel = $localize`:Paginator label@@paginatorPreviousPageLabel:Previous page`;

	getRangeLabel(page: number, pageSize: number, length: number): string {
		const pageTop = (page + 1) * pageSize;

		const numBottom = Math.min((pageTop - pageSize) + 1, length);
		const numTop = Math.min(pageTop, length);


		return $localize`:Paginator label@@paginatorRangePageItemsLabel:${numBottom}-${numTop} of ${length} items`;
	}
}

@Component({
	selector: 'app-ad-preview-pagination',
	templateUrl: './ad-preview-pagination.component.html',
	styleUrls: ['./ad-preview-pagination.component.scss']
})
export class AdPreviewPaginationComponent {
	@Input() length: number = 0;
	@Input() totalLength: number = 0;
	@Input() overrideLengthWithTotal: boolean = false;

	@Input() hideRangeLabel: boolean = false;
	@Input() overridePageCount: number | null = null;
	@Input() showZoom: boolean = false;
	@Input() activeItem: CreativeUnitWithCustomizationsDto | null = null;
	@Input() previewScale: string;
	@Input() previewMaxHeight: number;

	@Output() paginatorChange: EventEmitter<{ pageIndex: number; pageSize: number }> = new EventEmitter<{ pageIndex: number; pageSize: number }>();

	@Output() previewScaleChange: EventEmitter<number> = new EventEmitter();
	@Output() previewMaxHeightChange: EventEmitter<number | undefined> = new EventEmitter();

	constructor(
		public paginationService: AdPreviewPaginationService
	) { }

}
